import React from 'react';

import { EditIcon, LocationMapPinIcon } from '@vlabs/icons';
import { GeopositionSubForm } from '@vlabs/shared/components/geoposition-sub-form/GeopositionSubForm';
import { Divider, Control, useModal, CircleAnimatedButton, useWindowSize } from '@vlabs/uikit';
import cn from 'classnames';
import { cloneDeep } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { buildLocationString } from '../../utils';
import st from './Geoposition.module.sass';
import { MapCell } from './map/MapCell';

function Geoposition() {
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const geopositionModal = useModal();
  const { getValues } = useFormContext();

  const formattedLocation = buildLocationString(getValues('location'));
  const longitude = getValues('location.geo_position.longitude');
  const latitude = getValues('location.geo_position.latitude');
  const isGeoCoordinates = longitude && latitude;
  const isEditLocation = formattedLocation || isGeoCoordinates;

  return (
    <div className={st.Geoposition}>
      {geopositionModal.wrap(<GeopositionSubForm
        closeModal={geopositionModal.close}
      />)}
      <h6>{t('videoAnalytics:editAndCreateStreamsPageTitles.geoposition')}</h6>
      <Divider small />
      <div className={st.MapBlock}>
        {isEditLocation && (
          <div className={st.MapBlock__EditButton}>
            <CircleAnimatedButton
              icon={<EditIcon />}
              onClick={geopositionModal.open}
              onSurface
            >
              {t('videoAnalytics:editAndCreateStreamsPageTitles.edit_geoposition')}
            </CircleAnimatedButton>
          </div>
        )}
        <MapCell
          height="300px"
          value={{ ...cloneDeep(getValues('location.geo_position')) }}
        />
        <Divider small />
        {!isEditLocation && (
          <Control.Button
            className={cn(st.MapBlock__SetButton, {
              [st.MapBlock__SetButton_large]: windowSize.width >= 1920,
            })}
            fullWidth
            icon={<LocationMapPinIcon />}
            onClick={geopositionModal.open}
            variant="dimmed"
          >
            {t('videoAnalytics:editAndCreateStreamsPageTitles.set_geoposition')}
          </Control.Button>
        )}
      </div>

      <div className={st.Location}>
        {formattedLocation && (
          <p className={st.Location__Row}>
            <span className={st.Location__Address}>{formattedLocation}</span>
          </p>
        )}

        {isGeoCoordinates && (
          <>
            <p className={st.Location__Row}>
              <span className={st.Location__Label}>{t('videoAnalytics:editAndCreateStreamsPageTitles.longitude')}</span>
              <span>{getValues('location.geo_position.longitude')}</span>
            </p>

            <p className={st.Location__Row}>
              <span className={st.Location__Label}>{t('videoAnalytics:editAndCreateStreamsPageTitles.latitude')}</span>
              <span>{getValues('location.geo_position.latitude')}</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Geoposition;
